import { AboutContainer, ImageSection } from './About.style'
import VerticalTimeline from '../VerticalTimeline/VerticalTimeline'
import BackgroundAbout from '../../assets/Timeline/background-about-2.png'

const About = () => {
    return(
        <AboutContainer>
            <p>Somos EUPHA Pharma</p>
            <h1>EUPHA</h1>
            <p>Somos una familia que trabaja con la representación exclusiva de diversos laboratorios de renombre a nivel mundial.
            <br /><br />Nos especializamos en:</p>
            <ImageSection>
              <img src={BackgroundAbout} alt='BackgroundAbout' />
            </ImageSection>
            <VerticalTimeline />
        </AboutContainer>
    )
}

export default About